import React from "react";
import Features from "../components/Features";

export default function PrivateWorldEliteCard() {
  return (
    <div className="elite-card-page">
      {/* HERO SECTION */}
      <section className="elite-hero">
        <div className="elite-left">
          <h1>Private World Elite Card</h1>
          <p>
            Experience banking without borders. The Private World Elite Card
            represents the pinnacle of Swiss precision — crafted for clients
            who expect more from their wealth, lifestyle, and freedom.
          </p>
          <p>
            From global concierge access to luxury travel benefits, our
            elite card delivers unmatched prestige and performance,
            backed by the security and trust of the Swiss financial system.
          </p>
        </div>
        <div className="elite-right">
          <img src="/service4.png" alt="Private World Elite Card" />
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="elite-details">
        <h2>Exclusive Privileges for the Global Citizen</h2>
        <p>
          The Private World Elite Card offers tailored solutions for international
          banking clients seeking excellence beyond the ordinary. Whether you’re
          managing wealth across continents or exploring luxury worldwide,
          every feature is designed to elevate your experience.
        </p>
        <ul>
          <li>✅ Complimentary access to 1,200+ global airport lounges</li>
          <li>✅ 24/7 personal concierge and travel assistance</li>
          <li>✅ Priority banking and investment insights</li>
          <li>✅ Enhanced foreign exchange and withdrawal limits</li>
          <li>✅ Exclusive partnerships with luxury brands worldwide</li>
        </ul>
      </section>

      {/* FEATURES SECTION */}
      <Features />
    </div>
  );
}

/* ---------------------- CSS BELOW ---------------------- */

const styles = `
.elite-card-page {
  background: #f8f9fb;
  color: #1a1a1a;
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  padding-bottom: 60px;
}

.elite-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 10%;
  gap: 40px;
  background: white;
}

.elite-left {
  flex: 1;
}

.elite-left h1 {
  font-size: 2.5rem;
  color: #b01724;
  margin-bottom: 20px;
}

.elite-left p {
  margin-bottom: 15px;
  font-size: 1.05rem;
  color: #333;
}

.elite-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.elite-right img {
  width: 90%;
  max-width: 480px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.12);
}

.elite-details {
  padding: 60px 10%;
  max-width: 1000px;
  margin: 0 auto;
}

.elite-details h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #111;
}

.elite-details p {
  margin-bottom: 20px;
  color: #444;
}

.elite-details ul {
  list-style: none;
  padding-left: 0;
}

.elite-details li {
  margin-bottom: 10px;
  font-size: 1rem;
}

@media (max-width: 900px) {
  .elite-hero {
    flex-direction: column;
  }
  .elite-right img {
    width: 100%;
  }
}
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}
